import { RangeDescriptor } from './RangeDescriptor';
import { FiltriSpedizioni } from '@/store';
import { ComparisonOperator } from '../enums/ComparisonOperator';
import { FinderBase } from './FinderBase';
import dayjs, { Dayjs } from 'dayjs';
import { StatoSpedizione } from '../enums/StatoSpedizioni';

export class FinderSpedizioni extends FinderBase
{
    public id?: RangeDescriptor<string>;

    public dataCreazioneDa?: Date;

    public dataCreazioneA?: Date;
    public stato?: StatoSpedizione;

    public numeroDDT?: string;

    public dataDDT?: string;

    public constructor(idFornitore: string, pagina?: number) {
        super();

        this.idFornitore = idFornitore;
        if(pagina) {
            this.numeroPagina = pagina;
        }
    }

    public ApplicaFiltri(filtri: FiltriSpedizioni, stato: StatoSpedizione | undefined) {
        if(filtri.numSpedizione) {
            this.id = new RangeDescriptor(ComparisonOperator.Equal, filtri.numSpedizione);
        }

        let dataDa = dayjs(filtri.dataSpedizioneDa, { utc: true });
        if(dataDa.isValid()) {
            this.dataCreazioneDa = dataDa.toDate();
        }

        let dataA = dayjs(filtri.dataSpedizioneA, { utc: true });
        if(dataA.isValid()) {
            this.dataCreazioneA = dataA.toDate();
        }

        this.stato = stato;
    }
}